import React, { useEffect } from "react";
import { usePageTransition } from "../services/hooks/usePageTransition";
import { useAuth } from "../services/hooks/useAuth";
import Loader from "../components/Loader";
import Rewards from "../components/Rewards";
import { useGlobal } from "../services/hooks/useGlobal";

export default function rewards() {
  const { startTransition, completeTransition } = usePageTransition();
  const { user } = useAuth(true);

  const { setPageTitle } = useGlobal();

  useEffect(() => {
    setPageTitle({
      pageTitle: `Rewards`,
    });

    return () => {
      setPageTitle({
        pageTitle: null,
      });
    };
  }, []);

  useEffect(() => {
    completeTransition();

    return () => {
      startTransition();
    };
  }, []);

  if (!user) {
    return <Loader absoluteCenter />;
  }

  return <Rewards />;
}
